import { useEffect, useState, useCallback } from "react";
import { Plus } from "lucide-react";
import api from "@/lib/api";
import { StatusBadge } from "@/components/admin/ui";
import QuickActionModal from "@/components/worker/QuickActionModal";

export default function WorkerLeads() {
  const [leads, setLeads] = useState([]);
  const [action, setAction] = useState(null);
  const load = useCallback(() => { api.get("/leads?mine=true&limit=50").then((r) => setLeads(r.data.items)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="font-head text-2xl font-extrabold text-[#0A1128]">My Leads</h1>
        <button onClick={() => setAction("lead")} data-testid="worker-add-lead" className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#1D4ED8] text-white font-semibold text-sm"><Plus size={16} /> Add</button>
      </div>
      {leads.length === 0 ? (
        <div className="bg-white rounded-2xl border border-slate-100 p-8 text-center">
          <p className="font-semibold text-[#0A1128]">No leads yet</p>
          <p className="text-sm text-slate-500 mt-1">Tap Add to record your first lead.</p>
        </div>
      ) : leads.map((l) => (
        <div key={l.id} className="bg-white rounded-2xl border border-slate-100 p-4" data-testid={`worker-lead-${l.lead_id}`}>
          <div className="flex items-start justify-between">
            <div>
              <div className="font-semibold text-[#0A1128]">{l.company}</div>
              <div className="text-xs text-slate-400 mt-0.5">{l.contact_name || "—"} · {l.phone || ""}</div>
              <div className="text-[11px] text-slate-400 font-mono-metric mt-0.5">{l.lead_id}</div>
            </div>
            <StatusBadge status={l.status} />
          </div>
        </div>
      ))}
      <QuickActionModal action={action} onClose={() => setAction(null)} onDone={load} />
    </div>
  );
}
